var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0081 7.76C10.5581 7.76 10.1881 7.63 9.89809 7.37C9.61809 7.1 9.47809 6.77 9.47809 6.38C9.47809 5.98 9.61809 5.65 9.89809 5.39C10.1881 5.12 10.5581 4.985 11.0081 4.985C11.4481 4.985 11.8081 5.12 12.0881 5.39C12.3781 5.65 12.5231 5.98 12.5231 6.38C12.5231 6.77 12.3781 7.1 12.0881 7.37C11.8081 7.63 11.4481 7.76 11.0081 7.76ZM12.2831 8.63V17H9.71809V8.63H12.2831Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltipIcon);
export default __webpack_public_path__ + "static/media/infoTooltipIcon.e2f21e43c2e18f00e7a91a5ebb7307a5.svg";
export { ForwardRef as ReactComponent };